import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    Modal,
    Text,
    Linking,
    TextInput
} from "react-native";

// import ActionSheet from 'react-native-actionsheet';
// import Clipboard from "@react-native-clipboard/clipboard";
import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import OrderNow from "./OrderNow";
import ProductDetails from "./ProductDetails";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;
const imgFile = require("../images/orderNow/image.png");
const backIcon = require("../images/orderNow/backArrow.png");
const plus = require("../images/Shop/plus.png");
const minus = require("../images/Shop/minus.png");
const giftIcon = require("../images/RedGift2.png");
const greenGiftIcon = require("../images/CheckOut/greengiftIcon.png");
const removeItem = require("../images/CheckOut/RemoveOrder.png");
const holdIcon = require("../images/CheckOut/holdIcon.png");
const closeIcon = require("../images/CheckOut/closeIcon.png");
const bonusView = require("../images/CheckOut/bonusImage.png");
const bin = require("../images/CheckOut/bin.png");
const imgCopy = require("../images/Profile/copy.png");
const awaitingRestock = require("../images/awaitingrestock.png");
import { LinearGradient } from 'expo-linear-gradient';

class Checkout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            order: {},
            itemQty: '',
            itemsInBasket: [],
            accountOnHold: false,
            showOnHoldPopUp: false,
            searchText: '',
            productID: '',
            showProductDetails: false,
            ordStatus: undefined,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.loadData();
        ServerOperations.getUserInfo().then(userInfo => {
            if (userInfo && userInfo.ON_HOLD && (userInfo.ON_HOLD === 'Y' || userInfo.ON_HOLD === true)) {
                this.setState({ accountOnHold: true });
            } else {
                this.setState({ accountOnHold: false });
            }
        });

    }

    loadData = async () => {
        // loaderHandler.showLoader(STRINGS.loading, this);
        const parsedItems = await Commons.getBasketItems();
        try {
            // const orderResp = await ServerOperations.calcOrderPrice(parsedItems);
            const orderResp = await Commons.calculateOrderPrice(parsedItems);
            this.setState({ products: orderResp.ITEMS, order: orderResp });
        } catch (e) {
            console.log('Failed to parse ITEMS_IN_BASKET:', e);
            console.log(itemsInBasket);
        }
        const resp = await ServerOperations.placeOrder(parsedItems, true);
        console.log('Order Status Response:', resp);
        this.setState({ ordStatus: resp });
        // loaderHandler.hideLoader();
    }


    renderHeader = () => {
        return (
            <View style={{
                marginVertical: 20,
                flexDirection: 'row', alignItems: 'center',
                marginHorizontal: 32, alignSelf: "stretch", justifyContent: "flex-start", backgroundColor: AppStyles.desktopBackgroundColor
            }}>
                <Text style={[AppStyles.checkOutCart]}>{STRINGS.checkOut_cart}</Text>
            </View>
        )
    }

    renderMobileHeader = () => {
        return (
            [<View style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginHorizontal: 16,
                alignSelf: "stretch",
                justifyContent: "space-between",
                backgroundColor: '#fff',
                height: 56,
            }}>
                {/* Back Arrow on the left */}
                <TouchableOpacity
                    style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        paddingLeft: 4,
                    }}
                    onPress={() => {
                        this.props.navigation?.goBack?.();
                        window.location = './shop';
                    }}
                >
                    <Image source={backIcon} style={{ width: 17, height: 17 }} />
                </TouchableOpacity>
                {/* Centered Title */}
                <Text style={[AppStyles.H2Styles]}>{STRINGS.checkOut_cart}</Text>
                <View style={{ width: 32 }} />
            </View>,
            this.state.accountOnHold && (
                <TouchableOpacity
                    onPress={() => this.setState({ showOnHoldPopUp: true })}
                    style={{
                        justifyContent: 'flex-start',
                        flexDirection: 'row',
                        alignItems: 'center',
                        alignSelf: 'stretch',
                        borderRadius: 10,
                        backgroundColor: '#F9DBDB',
                        width: width - 32,
                        height: 40,
                        marginHorizontal: 16,
                        marginBottom: 20,
                    }}>
                    <View style={{ flexDirection: 'row', marginHorizontal: 16, justifyContent: 'center', alignItems: 'center' }}>
                        <Image source={holdIcon} style={{ width: 15.574, height: 13.999, tintColor: Styles.appColor1, }} />
                        <Text style={[AppStyles.orderListText]}> {STRINGS.account_onHold}</Text>
                    </View>
                </TouchableOpacity>
            ),

            <View style={{
                position: 'absolute',
                top: 50 + (this.state.accountOnHold ? 55 : 0),
                left: 0,
                right: 0,
                height: 40,
                background: 'linear-gradient(rgba(255, 255, 255, 0.9), transparent)',
                pointerEvents: 'none',
                zIndex: 1
            }} />]
        );
    }

    renderDeleteAllButton = () => {
        return (
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 16, marginBottom: 8, width, marginTop: 20,
            }}>
                <Text style={[AppStyles.cartTextItems,]}>
                    {STRINGS.checkOut_cart}
                </Text>
                <TouchableOpacity style={{ flexDirection: 'row', gap: 4, alignItems: 'center' }}
                    onPress={() => { this.clearAllItems(); }}>
                    <Text style={[AppStyles.clearCheckOut,]} > {STRINGS.clear_checkOut} </Text>
                    <Image source={bin} style={{ width: 13.321, height: 14.154, tintColor: '#9197B3' }} />
                </TouchableOpacity>
            </View>
        )
    }



    renderMobile() {
        scale = width / 420;
        return (
            [this.state.showProductDetails &&
                <View style={{ position: 'absolute', flex: 1, minHeight: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                    <ProductDetails self={this} productID={this.state.productID} showProductsDetails={() => {
                        this.setState({ showProductDetails: false });
                        this.loadData();
                    }} />
                </View>,
            <View style={[styles.container, { backgroundColor: '#fff' }]}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {Commons.loadFonts(this, false)}
                {this.renderMobileHeader()}
                {this.popUpAccountOnHold()}
                <ScrollView
                    style={{ flex: 1 }}
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200}
                    showsVerticalScrollIndicator={false}
                    onScroll={(e) => Commons.onHeaderScroll(e, this)}
                    contentContainerStyle={{}}>
                    <View style={{ width, backgroundColor: '#ffffff' }}>
                        {this.renderDeleteAllButton()}
                        {this.renderPart1Mobile()}
                    </View>
                    {this.renderPart2Mobile()}
                </ScrollView>
                {/* <View style={{ 
                    position: 'absolute', 
                    bottom: 0, 
                    left: 0, 
                    right: 0, 
                    backgroundColor: '#fff',
                    elevation: 5,
                    height: height / 2.5,
                }}> */}

                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
                {/* </View> */}
                {/* {this.renderPlaceOrderButton()} */}
            </View >
            ]);
    }

    renderQuantitySelector = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: descMarginTop }}>
                <View style={[
                    AppStyles.noBonusStyle,
                    {
                        flexDirection: 'row',
                        gap: isMobile ? 5 : 15,
                        padding: 4,
                        paddingHorizontal: 8,
                        alignItems: 'center',
                        backgroundColor: qtyBgColor,
                        borderRadius: 20,
                        justifyContent: 'space-between',
                    }
                ]}>
                    <TouchableOpacity
                        style={{ zIndex: 3, width: 8, paddingVertical: 5 }}
                        onPress={() => {
                            this.setState(prevState => {
                                const cartQty = { ...(prevState.cartQty || {}) };
                                cartQty[item.ID] = Math.max((cartQty[item.ID] || item.qty || 0) - 1, 0);
                                // Also update products array qty
                                const products = prevState.products.map(p =>
                                    p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                );
                                if (cartQty[item.ID] <= 0) {
                                    products.splice(index, 1);
                                }
                                this.updateProducts(products);
                                return { products };
                            });
                        }}>
                        <Image source={minus} style={{ width: 6, height: 1, tintColor: qtyTextColor }} />
                    </TouchableOpacity>
                    <View style={{
                        zIndex: 3,
                        backgroundColor: qtyBoxBg,
                        paddingHorizontal: 12,
                        paddingVertical: 6,
                        minWidth: qtyBoxMinWidth,
                        alignItems: 'center',
                        borderRadius: 3
                    }}>
                        <Text style={[AppStyles.featuredItemsQtyMiniStyle, { color: qtyTextColor }]}>{item.qty || 0}</Text>
                    </View>
                    <TouchableOpacity
                        style={{ zIndex: 3, width: 8, height: 12 }}
                        onPress={() => {
                            // Increase qty for this item
                            this.setState(prevState => {
                                const cartQty = { ...(prevState.cartQty || {}) };
                                cartQty[item.ID] = (cartQty[item.ID] || item.qty || 0) + 1;
                                const products = prevState.products.map(p =>
                                    p.ID === item.ID ? { ...p, qty: (p.qty || 0) + 1 } : p
                                );
                                this.updateProducts(products);
                                return { products };
                            });
                        }}>
                        <Image source={plus} style={{ width: 7, height: 7, tintColor: qtyTextColor }} />
                    </TouchableOpacity>
                </View>
            </View>
        )
    }

    render() {

        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            styles = this.styles();
            return this.renderMobile();
        }
        if (!this.props.self) {
            window.location = './ClientHomePage?tab=' + STRINGS.checkout;
            return;
        } else {
            this.props.self.currentComponent = this;
        }

        width = (Commons.getDesktopWidth());
        height = (Commons.getDesktopHeight());
        styles = this.styles();
        const part2Width = 300;
        const part1Width = Math.min(810, width - part2Width - 100);
        console.log('Part1Width:', part1Width);
        return (
            [
                this.state.showProductDetails &&
                <View style={{ position: 'absolute', flex: 1, minHeight: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100 }}>
                    <ProductDetails self={this} productID={this.state.productID} showProductsDetails={() => {
                        this.setState({ showProductDetails: false });
                        this.loadData();
                    }} />
                </View>,
                <View style={[styles.container, { backgroundColor: AppStyles.desktopBackgroundColor, height, alignItems: 'center', justifyContent: "space-between" }]}>
                    <View style={{ backgroundColor: AppStyles.desktopBackgroundColor, width: width - 30, paddingRight: 30 }}>
                        {Commons.renderAppHeader('', this, true, this.state.products, this.state.products, this.state.isSearch, this.state.searched, this.state.searchText, this.state.itemsNo)}
                    </View>
                    {this.state.showOrderNow && (
                        <View style={{ position: 'absolute', height, zIndex: 100 }}>
                            <OrderNow self={this}
                                consumerBrandFilter={this.state.filterID} consumerBrandName={this.state.filterName} isOffers={this.state.isOffers}
                                categoryFilter={this.state.categoryFilter} isBestSellers={this.state.isBestSellers} isFeatured={this.state.isFeatured}
                                allFilters={this.state.allFilters}
                                isAdv={this.state.isAdv}
                                isAdvProducts={this.state.isAdvProducts}
                                products={this.props.products}
                                searchText={this.state.searchText}
                                showOrderNow={(show) => {
                                    this.setState({
                                        showOrderNow: show
                                    });
                                }}
                            />
                        </View>
                    )}
                    {this.popUpAccountOnHold()}
                    {this.renderHeader()}
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', flex: 1, paddingHorizontal: 30, paddingVertical: 20, width: width - 20, backgroundColor: AppStyles.desktopBackgroundColor }}>
                        {Styles.renderSeparator(0)}
                        <ScrollView style={{
                            width: part1Width, flexGrow: 0, height: height - 170, maxHeight: height - 200
                            , backgroundColor: '#fff', paddingHorizontal: 16, borderRadius: 20
                        }} showsVerticalScrollIndicator={false}>
                            {/* Cart Items List */}
                            {this.state.products.map((item, index) => (
                                <View key={item.ID}>
                                    <View style={{
                                        flexDirection: 'row',
                                        paddingVertical: 16,
                                        paddingHorizontal: 0,
                                    }}>
                                        {/* Bonus View - Above Image */}
                                        <View style={{ marginRight: 15, alignItems: 'center', marginLeft: 6 }}>
                                            <View style={{ flexDirection: 'row', position: 'absolute', left: 0, zIndex: 2 }}>
                                                {item.NEXT_BONUS_TEXT && (
                                                    <View
                                                        source={bonusView}
                                                        style={{
                                                            paddingVertical: 8,
                                                            paddingHorizontal: 8,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            position: 'relative',
                                                            backgroundColor: '#EF897D',
                                                            borderRadius: 10
                                                        }}
                                                        resizeMode="contain"
                                                    >
                                                        {/* Gift icon positioned at top-left */}
                                                        <Image source={giftIcon} style={{
                                                            width: 18.4,
                                                            height: 18.4,
                                                            // tintColor: '#FFF',
                                                            position: 'absolute',
                                                            top: -6,
                                                            left: -6
                                                        }} />
                                                        {/* Centered text */}
                                                        <Text style={{
                                                            color: '#FFF',
                                                            fontSize: 12,
                                                            fontWeight: '700',
                                                        }}>
                                                            {item.NEXT_BONUS_TEXT}
                                                        </Text>
                                                    </View>
                                                )}
                                                {this.renderAwaitingRestock(item)}
                                            </View>
                                            {(item.NEXT_BONUS_TEXT || item.OOS) && Styles.renderVSeparator(37)}

                                            {/* Product Image */}
                                            <TouchableOpacity onPress={() => this.setState({ showProductDetails: true, productID: item.ID })}>
                                                <Image
                                                    source={item.IMG === '' ? imgFile : { uri: item.IMG }}
                                                    style={{ width: 88, height: 88 }}
                                                    resizeMode="contain"
                                                />
                                            </TouchableOpacity>

                                        </View>

                                        {/* Product Info */}

                                        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 4, flexGrow: 1 }}>
                                            <TouchableOpacity style={[{ gap: 8 }, (item.NEXT_BONUS_TEXT || item.OOS) && { marginTop: 32 }]}
                                                onPress={() => this.setState({ showProductDetails: true, productID: item.ID })}
                                            >
                                                <Text
                                                    style={[AppStyles.checkOutDescStyle, { textTransform: 'capitalize', flexGrow: 1, maxWidth: 300, width: part1Width - 263 - 170 }]}
                                                    numberOfLines={2}
                                                    ellipsizeMode="tail"

                                                >
                                                    {item.NAME.toLowerCase()}
                                                </Text>
                                                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                                                    <Text
                                                        style={[AppStyles.priceJODTextStyle, { fontSize: 14 }]}
                                                    >
                                                        {item.PHARMACY_PRICE}
                                                    </Text>
                                                    {
                                                        item.NORET == "1" && <Text style={[AppStyles.CheckoutNORetStyle]}>
                                                            *Non-returnable Item
                                                        </Text>
                                                    }
                                                </View>
                                            </TouchableOpacity>
                                            {<View style={{ flexGrow: 1 }} />}
                                            {/* Bonus and Quantity Controls Container */}
                                            <View style={[{
                                                flexDirection: 'column',
                                                gap: 10,
                                                alignItems: 'center',
                                                backgroundColor: '#fff',
                                                borderRadius: 20,
                                                paddingHorizontal: 6,
                                                paddingVertical: 4,
                                                marginRight: 16,
                                                minWidth: 80,
                                                width: 263,
                                            }, (item.NEXT_BONUS_TEXT || item.OOS) && { marginTop: 32 }]}>
                                                <View style={{
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    backgroundColor: '#fff',
                                                    borderRadius: 20,
                                                    paddingHorizontal: 6,
                                                    paddingVertical: 4,
                                                    marginRight: 16,
                                                    width: 263,
                                                    minWidth: 80,
                                                    gap: 8,
                                                }}>
                                                    {/* Quantity Controls */}
                                                    <View style={{
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        backgroundColor: '#fff',
                                                        borderRadius: 25,
                                                        paddingHorizontal: 4,
                                                        paddingVertical: 2,
                                                        minWidth: 80,
                                                        gap: 10,
                                                    }}>
                                                        <TouchableOpacity
                                                            style={{
                                                                width: 24,
                                                                height: 24,
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}
                                                            onPress={() => {
                                                                this.setState(prevState => {
                                                                    const products = prevState.products.map(p =>
                                                                        p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                                                    ).filter(p => p.qty > 0);
                                                                    this.updateProducts(products);
                                                                    return { products };
                                                                });
                                                            }}
                                                        >
                                                            <Image source={minus} style={{ width: 9, height: 1, tintColor: Styles.appColor1 }} />
                                                        </TouchableOpacity>

                                                        {/* Quantity Display with Bonus Above */}
                                                        <View style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', borderTopRightRadius: 4, borderTopLeftRadius: 4, }}>
                                                            {/* {item.BONUS !== '' && item.BONUS > 0 && (
                                                                <Text style={[AppStyles.desktopBonusItems, { height: 18, fontFamily: 'Inter', marginTop: 2 }]}>
                                                                    +{item.BONUS}
                                                                </Text>
                                                            )} */}
                                                            {item.BONUS !== '' && item.BONUS > 0 && (
                                                                <View style={{
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    alignSelf: 'center',
                                                                    position: 'absolute',
                                                                    top: -20,

                                                                }}>
                                                                    <Text style={[AppStyles.giftText]}>+{item.BONUS} </Text>
                                                                    <Image source={greenGiftIcon} style={{ width: 11.6, height: 11.665, marginRight: 4 }} />
                                                                </View>
                                                            )}
                                                            {this.state.ordStatus && this.state.ordStatus.QTY_ERROR_ITEMS && this.state.ordStatus.QTY_ERROR_ITEMS[item.ID] == "1" && (
                                                                <View style={{
                                                                    flexDirection: 'row',
                                                                    alignSelf: 'center',
                                                                    position: 'absolute',
                                                                    top: -17,
                                                                    width: 115,
                                                                    height: 30,
                                                                    zIndex: 99,
                                                                }}>
                                                                    <LinearGradient
                                                                        colors={['#fff', '#fff', 'transparent']}
                                                                        start={{ y: 0 }}
                                                                        end={{ y: 1 }}
                                                                    >

                                                                        <Text style={AppStyles.CheckoutQtyErrorStyle} >{STRINGS.qty_limit_reached}</Text>
                                                                    </LinearGradient>
                                                                </View>
                                                            )}
                                                            <View style={{
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                paddingHorizontal: 8,
                                                                backgroundColor: '#F0F6FC',
                                                                borderTopRightRadius: 4,
                                                                borderTopLeftRadius: 4,
                                                                minWidth: 45,
                                                                height: 28,
                                                                paddingVertical: 6,
                                                                position: 'relative',

                                                            }}>
                                                                {/* Quantity Number */}
                                                                <Text style={[AppStyles.featuredItemsQtyStyle, { color: Styles.appColor1, fontSize: 14, fontWeight: '700' }]}>
                                                                    {item.qty || 0}
                                                                </Text>
                                                            </View>
                                                        </View>

                                                        <TouchableOpacity
                                                            style={{
                                                                width: 24,
                                                                height: 24,
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}
                                                            onPress={() => {
                                                                this.setState(prevState => {
                                                                    const products = prevState.products.map(p =>
                                                                        p.ID === item.ID ? { ...p, qty: (p.qty || 0) + 1 } : p
                                                                    );
                                                                    this.updateProducts(products);
                                                                    return { products };
                                                                });
                                                            }}
                                                        >
                                                            <Image source={plus} style={{ width: 9, height: 9, tintColor: Styles.appColor1 }} />
                                                        </TouchableOpacity>
                                                    </View>


                                                    <Text style={[AppStyles.checekOutPriceStyleDesktop, {
                                                        width: 100,
                                                        textAlign: 'center',
                                                        flexShrink: 0,
                                                        numberOfLines: 1,
                                                    }]} numberOfLines={1}>
                                                        {item.PHARMACY_PRICE} JOD
                                                    </Text>

                                                    <TouchableOpacity
                                                        style={{ padding: 8, }}
                                                        onPress={() => {
                                                            this.setState(prevState => {
                                                                const products = prevState.products.filter(p => p.ID !== item.ID);
                                                                this.updateProducts(products);
                                                                return { products };
                                                            });
                                                        }}
                                                    >
                                                        <Image source={removeItem} style={{ width: 12, height: 12, tintColor: AppStyles.appColor1 }} />
                                                    </TouchableOpacity>
                                                </View>

                                                {item.BONUS !== '' && item.NEXT_BONUS_TEXT !== '' && (
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            this.setState(prevState => ({
                                                                bonusAdded: {
                                                                    ...(prevState.bonusAdded || {}),
                                                                    [item.ID]: true
                                                                }
                                                            }));
                                                            Commons.addItemsToBasket(this, item, item.ID, item.NEXT_BONUS);
                                                            this.setState(prevState => {
                                                                const products = prevState.products.map(p =>
                                                                    p.ID === item.ID ? { ...p, qty: item.NEXT_BONUS } : p
                                                                );
                                                                this.updateProducts(products);
                                                                return { products };
                                                            });
                                                        }}
                                                        style={{
                                                            width: 245,
                                                            height: 22,
                                                            paddingVertical: 4, justifyContent: "center", alignItems: 'center',
                                                            borderRadius: 8.631, backgroundColor: '#EF897D', flexDirection: 'row',
                                                        }}>
                                                        <Image source={giftIcon} style={{ height: 14.084, width: 14.16, marginHorizontal: 13.8 }} />
                                                        <Text style={[AppStyles.checkOutDescStyle, { color: '#FFF', fontSize: 12.974, }]}>{item.NEXT_BONUS_TEXT_LONG}</Text>
                                                    </TouchableOpacity>
                                                )}
                                            </View>

                                        </View>

                                    </View>
                                    {/* Line separator */}
                                    {index < this.state.products.length - 1 && (
                                        <View style={{ height: 1, backgroundColor: '#E0E0E0', marginVertical: 0 }} />
                                    )}
                                </View>
                            ))}
                        </ScrollView>
                        {Styles.renderSeparator(30)}
                        {/* Right side - Order Summary */}
                        < View style={{ backgroundColor: '#fff', height: 'fit-content', justifyContent: 'center', alignItems: 'center', width: part2Width, borderRadius: 20 }}>
                            {/* Account on Hold Banner */}
                            {this.state.accountOnHold && (
                                <TouchableOpacity
                                    onPress={() => this.setState({ showOnHoldPopUp: true })}
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        backgroundColor: '#F9DBDB',
                                        padding: 12,
                                        width: part2Width,
                                        borderTopRightRadius: 20,
                                        borderTopLeftRadius: 20,
                                        marginTop: -50
                                    }}
                                >
                                    <Image source={holdIcon} style={{ width: 16, height: 14, tintColor: Styles.appColor1, marginRight: 8 }} />
                                    <Text style={[AppStyles.orderListText]}>{STRINGS.account_onHold}</Text>
                                </TouchableOpacity>
                            )}
                            {this.state.ordStatus && this.state.ordStatus.CREDIT_LIMIT_ERROR == "1" && (
                                <TouchableOpacity
                                    onPress={() => this.setState({ showOnHoldPopUp: true })}
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        backgroundColor: '#F9DBDB',
                                        padding: 12,
                                        width: part2Width,
                                        borderTopRightRadius: 20,
                                        borderTopLeftRadius: 20,
                                        marginTop: -50
                                    }}
                                >
                                    <Image source={holdIcon} style={{ width: 16, height: 14, tintColor: Styles.appColor1, marginRight: 8 }} />
                                    <Text style={[AppStyles.orderListText]}>{`You’ve Reached Your Customer Limit`}</Text>
                                </TouchableOpacity>
                            )}

                            <View style={{ width: part2Width, paddingHorizontal: 30, marginTop: 30 }}>
                                <Text style={[AppStyles.checkOutDelevery, {
                                    fontSize: 16,
                                    fontWeight: '500',
                                    marginBottom: 8,
                                    width: width - 96,
                                    textAlign: 'left',

                                }]}>
                                    {STRINGS.notes}
                                </Text>
                                <TextInput
                                    style={[
                                        AppStyles.checkoutNotesStyle,
                                        {
                                            overflow: 'hidden',
                                            textAlignVertical: 'top',
                                            minHeight: this.state.notesHeight || 35,
                                            backgroundColor: '#fff',
                                            borderWidth: 1,
                                            borderColor: '#A6A6A6',
                                            borderRadius: 4,
                                            padding: 8
                                        }
                                    ]}
                                    scrollEnabled={false}
                                    onContentSizeChange={(e) => {
                                        const h = e?.nativeEvent?.contentSize?.height || 35;
                                        this.setState({ notesHeight: Math.min(h, 160) });
                                    }}
                                    multiline={true}
                                    value={this.state.notes}
                                    placeholder={"Order Notes (Optional)"}
                                    placeholderTextColor={'rgba(59, 98, 127, 0.50)'}
                                    onChangeText={(text) => { this.setState({ notes: text }) }}
                                />
                            </View>

                            <Text style={[AppStyles.checkOutDelevery, { fontSize: 18, fontWeight: '700', marginBottom: 16, marginTop: 30, width: part2Width, paddingHorizontal: 30 }]}>
                                Order Summary
                            </Text>

                            {/* Order Summary Details */}
                            <View style={{ marginBottom: 16, paddingHorizontal: 30, marginTop: 10, width: part2Width }}>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}>
                                    <Text style={AppStyles.orderSummarySubTotalText}>Subtotal</Text>
                                    <Text style={AppStyles.orderSummarySubTotalAmount}>{this.state.order.SUBTOTAL}</Text>
                                </View>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}>
                                    <Text style={AppStyles.orderSummaryDiscount}>Discount</Text>
                                    <Text style={AppStyles.orderSummarySubTotalAmount}>0.00</Text>
                                </View>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}>
                                    <Text style={AppStyles.orderSummaryDiscount}>Tax</Text>
                                    <Text style={AppStyles.orderSummarySubTotalAmount}>{this.state.order.TAX}</Text>
                                </View>
                                <View style={{ height: 1, backgroundColor: '#E0E0E0', marginVertical: 12 }} />
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 16, }}>
                                    <Text style={[AppStyles.checkOutPaymentTermsBold, { color: Styles.appColor1 }]}>
                                        Total
                                    </Text>
                                    <Text style={[AppStyles.orderSummarySubTotalAmount, { color: Styles.appColor1 }]}>
                                        {this.state.order.ESTIMATED_TOTAL}
                                    </Text>
                                </View>
                            </View>

                            {/* Delivery Info */}
                            <View style={{ marginBottom: 20, width: part2Width, paddingHorizontal: 30 }}>
                                <Text style={[AppStyles.checkOutDelvDesktop, { marginBottom: 4 }]}>Delivery</Text>
                                <Text style={AppStyles.checkOutExpectDateDesktop}>
                                    Expected by {this.state.order.EXPECTED_DATE}
                                </Text>
                            </View>

                            {/* Place Order Button */}
                            <TouchableOpacity
                                style={[AppStyles.placeOrderButtonDesktop, { marginTop: 10, marginBottom: 40, alignSelf: 'flex-start', marginHorizontal: 30, width: part2Width - 60 }]}
                                onPress={this.placeOrder}
                            >
                                <Text style={AppStyles.loginButtonTextStyles}>
                                    {STRINGS.checkOut_Place_Order}
                                </Text>
                            </TouchableOpacity>
                        </View>
                        {Styles.renderSeparator(0)}
                    </View>
                </View >]
        );
    }



    renderPart1 = () => {

    }

    updateProducts = async (products) => {
        await Commons.saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify(products));
        this.loadData();
    }

    clearAllItems = async () => {
        await Commons.saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify([]));
        this.loadData();
    }

    popUpAccountOnHold = () => {
        return (
            <Modal
                visible={this.state.showOnHoldPopUp}
                transparent={true}
                animationType="fade"
                onRequestClose={() => this.setState({ showOnHoldPopUp: false })}
            >
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'rgba(255,255,255,0.4)', // white with opacity
                        justifyContent: 'center',
                        alignItems: 'center',

                    }}
                >
                    <View
                        style={{
                            backgroundColor: '#fff',
                            padding: 24,
                            width: width * 0.8,
                            maxWidth: 450,
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 16,
                            borderWidth: 1,
                            borderColor: 'rgba(215, 215, 215, 0.50)',
                        }}
                    >
                        <TouchableOpacity
                            style={{
                                position: 'absolute',
                                right: 12,
                                top: 12,
                                zIndex: 10,
                            }}
                            onPress={() => this.setState({ showOnHoldPopUp: false })}
                        >
                            <Image source={closeIcon} style={{ width: 16, height: 16 }} />
                        </TouchableOpacity>
                        <Text style={[AppStyles.accountHoldHeader, { marginTop: 15 }]}>
                            {STRINGS.account_onHold}
                        </Text>
                        <Text style={[AppStyles.accountHoldText, { marginBottom: 24, marginTop: 16 }]}>
                            {STRINGS.acc_hold_message}
                        </Text>
                        <TouchableOpacity style={[AppStyles.loginButtonStyles, {
                            paddingVertical: 10, paddingHorizontal: 32, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 8
                        }]}
                            onPress={() => {
                                ServerOperations.getUserInfo().then((resp) => {
                                    // Clipboard.setString(resp.SALESMAN_PHONE);
                                    Linking.openURL(`tel:${resp.SALESMAN_PHONE}`);
                                });
                            }}
                        >
                            <Image source={imgCopy} style={{ width: 19.2, height: 19.2, tintColor: '#FFF' }} />
                            <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.sales_rep}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>
        )
    }

    showProductsDetails = (item) => {
        this.setState({ productID: item.ID, showProductDetails: true });
    }

    renderPart1Mobile = () => {
        const cartItems = this.state.products.map((item, index) => {
            var bonusStyle = AppStyles.wBonusStyle;
            if (item.BONUS === '') {
                bonusStyle = AppStyles.noBonusStyle;
            }
            return (
                <View>
                    <View style={{
                        flexDirection: 'row',
                        width: width,
                        marginVertical: 8,
                        backgroundColor: '#fff',
                        borderRadius: 12,
                    }}>
                        <TouchableOpacity
                            style={{ position: 'absolute', right: 32, top: 16, zIndex: 10 }}
                            onPress={() => {
                                this.setState(prevState => {
                                    const cartQty = { ...(prevState.cartQty || {}) };
                                    cartQty[item.ID] = 0;
                                    // Also update products array qty
                                    const products = prevState.products.map(p =>
                                        p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                    );
                                    if (cartQty[item.ID] <= 0) {
                                        products.splice(index, 1);
                                    }
                                    this.updateProducts(products);
                                    return { products };
                                });

                            }}>
                            <Image source={removeItem} style={{ width: 16, height: 16 }} />
                        </TouchableOpacity>

                        {/* Product Image Container */}
                        <View style={{ marginRight: 16, alignItems: 'center', marginTop: 10 }}>
                            {item.BONUS !== '' && item.NEXT_BONUS > 0 && (
                                <View
                                    source={bonusView}
                                    style={{
                                        paddingVertical: 8,
                                        paddingHorizontal: 12,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                        padding: 8,
                                        backgroundColor: '#EF897D',
                                        borderRadius: 6
                                    }}
                                    resizeMode="contain"
                                >
                                    {/* Gift icon positioned at top-left */}
                                    <Image source={giftIcon} style={{
                                        width: 18,
                                        height: 18,
                                        // tintColor: '#FFF',
                                        position: 'absolute',
                                        top: -5,
                                        left: -5
                                    }} />
                                    {/* Centered text */}
                                    <Text style={{
                                        color: '#FFF',
                                        fontSize: 12,
                                        fontWeight: '700',
                                    }}>
                                        {item.NEXT_BONUS_TEXT}
                                    </Text>
                                </View>
                            )}

                            {/* Product Image */}
                            <TouchableOpacity onPress={() => this.setState({ showProductDetails: true, productID: item.ID })}>
                                <Image
                                    source={item.IMG === '' ? imgFile : { uri: item.IMG }}
                                    style={{ width: 88, height: 88, borderRadius: 8 }}
                                    resizeMode="contain"
                                />
                            </TouchableOpacity>
                            {this.renderAwaitingRestock(item)}
                        </View>

                        {/* Product Info */}
                        <View style={{ flex: 1, marginRight: 12 }}>
                            {item.BONUS !== '' && item.NEXT_BONUS_TEXT !== '' && (
                                <TouchableOpacity
                                    onPress={() => {
                                        this.setState(prevState => ({
                                            bonusAdded: {
                                                ...(prevState.bonusAdded || {}),
                                                [item.ID]: true
                                            }
                                        }));
                                        Commons.addItemsToBasket(this, item, item.ID, item.NEXT_BONUS);
                                        this.setState(prevState => {
                                            const products = prevState.products.map(p =>
                                                p.ID === item.ID ? { ...p, qty: item.NEXT_BONUS } : p
                                            );
                                            this.updateProducts(products);
                                            return { products };
                                        });
                                    }}
                                    style={{
                                        marginTop: 10,
                                        paddingVertical: 4,
                                        paddingHorizontal: 12,
                                        borderRadius: 16,
                                        backgroundColor: '#EF897D',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        alignSelf: 'flex-start',
                                        justifyContent: 'center',
                                    }}>
                                    <Image source={giftIcon} style={{ height: 14, width: 14, marginRight: 6 }} />
                                    <Text style={{ color: '#FFF', fontSize: 11, fontWeight: '700', fontFamily: AppStyles.fontFamily }}>
                                        {item.NEXT_BONUS_TEXT_LONG}
                                    </Text>
                                </TouchableOpacity>
                            )}

                            <Text style={
                                [
                                    AppStyles.checkOutDescStyle,
                                    { marginBottom: 4, marginTop: 10, textTransform: 'capitalize', width: width - 160, }]}
                                numberOfLines={2}>
                                {item.NAME.toLowerCase()}
                            </Text>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Text style={[AppStyles.checkOutPriceStyle, {}]}>
                                    {item.PHARMACY_PRICE} JOD
                                </Text>
                                {
                                    item.NORET == "1" && <Text style={[AppStyles.CheckoutNORetStyle, { marginLeft: 12 }]}>
                                        *Non-returnable Item
                                    </Text>
                                }
                                <View style={{}}>
                                    {/* Bonus display above quantity */}
                                    {item.BONUS !== '' && item.BONUS > 0 && (
                                        <View style={{
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            paddingHorizontal: 16,
                                            paddingVertical: 4,
                                            borderRadius: 12,
                                        }}>
                                            <Image source={greenGiftIcon} style={{ width: 12, height: 12, marginRight: 4 }} />
                                            <Text style={[AppStyles.giftText, { fontSize: 10 }]}>+ {item.BONUS}</Text>
                                        </View>
                                    )}
                                    {/* Quantity Control Row */}
                                </View>

                            </View>

                            {/* Bonus offer button */}

                            <View style={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                backgroundColor: '#fff',
                                borderRadius: 20,
                                paddingHorizontal: 4,
                                paddingVertical: 4,
                                minWidth: 90,
                                gap: 10,
                            }}>
                                {this.state.ordStatus && this.state.ordStatus.QTY_ERROR_ITEMS && this.state.ordStatus.QTY_ERROR_ITEMS[item.ID] == "1" && (
                                    <View style={{
                                        flexDirection: 'row',
                                        alignSelf: 'center',
                                        position: 'absolute',
                                        top: -3,
                                        left: 0,
                                        width: '115px',
                                        height: '20px',
                                        zIndex: 99,
                                    }}>
                                        <LinearGradient
                                            colors={['#fff', '#fff', '#fff', 'transparent']}
                                            start={{ y: 0 }} // Gradient starts at the top center
                                            end={{ y: 1 }}
                                        >

                                            <Text style={AppStyles.CheckoutQtyErrorStyle} >{STRINGS.qty_limit_reached}</Text>
                                        </LinearGradient>
                                    </View>
                                )}
                                <TouchableOpacity
                                    style={{
                                        width: 28,
                                        height: 28,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#fff',
                                        borderRadius: 14,
                                    }}
                                    onPress={() => {
                                        this.setState(prevState => {
                                            const cartQty = { ...(prevState.cartQty || {}) };
                                            cartQty[item.ID] = Math.max((cartQty[item.ID] || item.qty || 0) - 1, 0);
                                            // Also update products array qty
                                            const products = prevState.products.map(p =>
                                                p.ID === item.ID ? { ...p, qty: Math.max((p.qty || 0) - 1, 0) } : p
                                            );
                                            if (cartQty[item.ID] <= 0) {
                                                products.splice(index, 1);
                                            }
                                            this.updateProducts(products);
                                            return { products };
                                        });
                                    }}>
                                    <Image source={minus} style={{ width: 10, height: 1.5, tintColor: Styles.appColor1 }} />
                                </TouchableOpacity>

                                <View style={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    paddingVertical: 8,
                                    paddingHorizontal: 16,
                                    backgroundColor: '#F0F6FC',
                                    // width: 40,
                                    height: 28,
                                    // maxWidth: 40,
                                    // minWidth: 40,
                                    borderRadius: 4
                                }}>
                                    <Text style={[AppStyles.featuredItemsCheckout, {
                                    }]}>
                                        {item.qty || 0}
                                    </Text>
                                </View>

                                <TouchableOpacity
                                    style={{
                                        width: 28,
                                        height: 28,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#fff',
                                        borderRadius: 14,
                                    }}
                                    onPress={() => {
                                        // Increase qty for this item
                                        this.setState(prevState => {
                                            const cartQty = { ...(prevState.cartQty || {}) };
                                            cartQty[item.ID] = (cartQty[item.ID] || item.qty || 0) + 1;
                                            const products = prevState.products.map(p =>
                                                p.ID === item.ID ? { ...p, qty: (p.qty || 0) + 1 } : p
                                            );
                                            this.updateProducts(products);
                                            return { products };
                                        });

                                    }}>
                                    <Image source={plus} style={{ width: 10, height: 10, tintColor: Styles.appColor1 }} />
                                </TouchableOpacity>



                                {/* {total price for the item} */}
                                <Text style={[AppStyles.checekOutPriceStyleDesktop, {
                                    width: 100,
                                    textAlign: 'center',
                                    flexShrink: 0,
                                    marginLeft: 20,
                                }]} numberOfLines={1}>
                                    {Math.round((item.qty || 0) * parseFloat(item.PHARMACY_PRICE) * 1000) / 1000 + " JOD"}
                                </Text>

                            </View>
                        </View>


                    </View>
                    {this.state.products.length != index + 1 && <View style={{ height: 1, width: width - 20, backgroundColor: '#E0E0E0', }} />}
                </View>
            );
        });
        return (
            <View style={{ marginHorizontal: 16, alignSelf: 'stretch', backgroundColor: '#fff', paddingVertical: 8 }}>
                <View>
                    {cartItems}
                </View>
            </View>
        )

    }

    renderAwaitingRestock(item) {
        if (item.OOS != "1") return null;
        if (isMobile) {
            return (
                <View style={{
                    position: 'absolute',
                    left: 16,
                    bottom: 10,
                    zIndex: 4,
                    borderRadius: 8,
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                }}>
                    <Image source={awaitingRestock} style={{ width: 35, height: 35 }} resizeMode="contain" />
                </View>
            );
        }
        return (
            <View style={{
                left: item.NEXT_BONUS_TEXT ? 8 : 0,
                zIndex: 4,
                backgroundColor: '#FF8E3D',
                borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10,
                height: 31,
                paddingHorizontal: 16
            }}>
                <Text style={{ color: '#FFFFFF', fontSize: 11, fontFamily: AppStyles.fontFamily, fontWeight: 700 }}>{STRINGS.awaiting_restock}</Text>
            </View>
        );
    }

    renderPart2Mobile = () => {
        return (
            <View style={{
                backgroundColor: AppStyles.desktopBackgroundColor,
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingHorizontal: 16,
                paddingVertical: 50
            }}>


                {/* Order Summary Details */}
                <View style={{ gap: 32 }}>

                    <View>
                        <Text style={[AppStyles.checkOutDelevery, {
                            fontSize: 16,
                            fontWeight: '500',
                            marginBottom: 8,
                            width: width - 96,
                            textAlign: 'left',

                        }]}>
                            {STRINGS.notes}
                        </Text>
                        <TextInput
                            style={[
                                AppStyles.checkoutNotesStyle,
                                {
                                    overflow: 'hidden',
                                    textAlignVertical: 'top',
                                    minHeight: this.state.notesHeight || 35,
                                    backgroundColor: '#fff',
                                    borderWidth: 1,
                                    borderColor: '#A6A6A6',
                                    borderRadius: 4,
                                    padding: 8
                                }
                            ]}
                            scrollEnabled={false}
                            onContentSizeChange={(e) => {
                                const h = e?.nativeEvent?.contentSize?.height || 35;
                                this.setState({ notesHeight: Math.min(h, 160) });
                            }}
                            multiline={true}
                            value={this.state.notes}
                            placeholder={"Order Notes (Optional)"}
                            placeholderTextColor={'rgba(59, 98, 127, 0.50)'}
                            onChangeText={(text) => { this.setState({ notes: text }) }}
                        />
                    </View>
                    <Text style={[AppStyles.checkOutDelevery, {
                        fontSize: 18,
                        fontWeight: '700',
                        marginBottom: 8,
                        width: width - 96,
                        textAlign: 'left',

                    }]}>
                        Order Summary
                    </Text>

                    <View style={{
                        marginBottom: 8,
                        width: width - 96,
                        justifyContent: 'center',
                        gap: 24
                    }}>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text style={AppStyles.orderSummarySubTotalText}>Subtotal</Text>
                            <Text style={AppStyles.orderSummarySubTotalAmount}>{this.state.order.SUBTOTAL}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text style={AppStyles.orderSummaryDiscount}>Discount</Text>
                            <Text style={AppStyles.orderSummarySubTotalAmount}>0.00</Text>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text style={AppStyles.orderSummaryDiscount}>Tax</Text>
                            <Text style={AppStyles.orderSummarySubTotalAmount}>{this.state.order.TAX}</Text>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text style={[AppStyles.checkOutPaymentTermsBold, { color: Styles.appColor1 }]}>Total</Text>
                            <Text style={[AppStyles.orderSummarySubTotalAmount, { color: Styles.appColor1 }]}>{this.state.order.ESTIMATED_TOTAL}</Text>
                        </View>

                        <View style={{ height: 1, backgroundColor: '#E0E0E0', marginBottom: 12 }} />

                    </View>
                    {/* Delivery Info */}
                    <View style={{ marginBottom: 12, gap: 8 }}>
                        <Text style={[AppStyles.checkOutDelvDesktop, { marginBottom: 2 }]}>Delivery</Text>
                        <Text style={AppStyles.checkOutExpectDateDesktop}>
                            Expected by {this.state.order.EXPECTED_DATE}
                        </Text>
                    </View>

                    <TouchableOpacity
                        style={[AppStyles.placeOrderButtonDesktop, {
                            width: width - 96,
                            alignSelf: 'center',
                        }]}
                        onPress={this.placeOrder}
                    >
                        <Text style={AppStyles.loginButtonTextStyles}>
                            {STRINGS.checkOut_Place_Order}
                        </Text>
                    </TouchableOpacity>
                </View>
                {/* Place Order Button */}
            </View>
        )

    }

    renderPart2 = () => {

    }

    placeOrder = async () => {
        loaderHandler.showLoader("Placing Order...", this);
        const items = await Commons.getBasketItems();
        const resp = await ServerOperations.placeOrder(items, false, this.state.notes);
        console.log('Place order response:', resp);
        if (resp && !resp.ERROR && resp.ORDERID) {
            // alert('Order Placed', 'Your order has been placed successfully.');
            await Commons.saveToAS(Constants.ITEMS_IN_BASKET, JSON.stringify([]));
            if (isMobile) {
                window.location = `./myorders`;
            } else {
                this.props.self.setState({ currentTab: STRINGS.Orders });
            }
        } else {
            alert('Order Failed ' + resp.MSG);
        }
        loaderHandler.hideLoader();
    }

    renderPlaceOrderButton = () => {
        return (
            <TouchableOpacity style={[AppStyles.loginButtonStyles, { marginHorizontal: 8, width: width - 18, maringTop: 5, marginBottom: 15 }]}
                onPress={this.placeOrder}
            >
                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.checkOut_Place_Order}</Text>
            </TouchableOpacity>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            height: 590,
        }
    });
}



export default Checkout;
